// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"165":"capital","177":"home","495":"drapeau","648":"departements"}[chunkId] + "." + {"165":"0d1d1a2c","177":"2463f660","495":"502d975a","648":"6f0abc36"}[chunkId] + ".css";
};